var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgBellStrikethrough = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  stroke: "currentColor",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  strokeWidth: 1.5,
  d: "M14.382 21.136a2 2 0 0 1-3.46 0M19.282 13.136a17.9 17.9 0 0 1-.63-5M6.911 6.396a5.9 5.9 0 0 0-.26 1.74c0 7-3 9-3 9h14M18.651 8.136a6 6 0 0 0-9.33-5M1.651 1.136l22 22"
})));
export default SvgBellStrikethrough;